var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.user.qrcode !== '' && _vm.user.state === 'new')?_c('v-card',[_c('v-card-text',{staticClass:"p-4"},[_c('v-img',{attrs:{"src":_vm.qr}})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }